// src/app/context/SearchContext.js
import React, {
  createContext,
  useContext,
  useState,
  useCallback,
} from "react";

const SearchContext = createContext(null);

const DEFAULT_STATE = {
  destination: "",
  startDate: "",
  endDate: "",
  adults: 0,
  children: 0,
  babies: 0,
};

export function SearchProvider({ children }) {
  const [search, setSearch] = useState(DEFAULT_STATE);
  const [sheetOpen, setSheetOpen] = useState(false);

  const updateSearch = useCallback((patch) => {
    setSearch((prev) => ({ ...prev, ...patch }));
  }, []);

  const resetSearch = useCallback(() => {
    setSearch(DEFAULT_STATE);
  }, []);

  return (
    <SearchContext.Provider value={{ search, updateSearch, resetSearch, sheetOpen, setSheetOpen }}>
      {children}
    </SearchContext.Provider>
  );
}

export function useSearch() {
  const ctx = useContext(SearchContext);
  if (!ctx) {
    return {
      search: DEFAULT_STATE,
      updateSearch: () => {},
      resetSearch: () => {},
      sheetOpen: false,
      setSheetOpen: () => {},
    };
  }
  return ctx;
}
